export const footer = [
    {
        Head:"Products",

        links : [
            {
                Link:"App",
            },
            {
                Link:"Token List",
            },
            {
                Link:"Defi",
            },
            {
                Link:"Sales",
            },
        ]
    },
    {
        Head:"Developers",

        links : [
            {
                Link:"Software",
            },
            {
                Link:"DataBase",
            },
            {
                Link:"Networking",
            },
            {
                Link:"DataProvider",
            },
        ]
    },
    {
        Head:"Government",

        links : [
            {
                Link:"Society",
            },
            {
                Link:"Community",
            },
            {
                Link:"CoOperation",
            },
            {
                Link:"Individual",
            },
        ]
    },
    {
        Head:"Community",

        links : [
            {
                Link:"CoOperation",
            },
            {
                Link:"Individuals",
            },
            {
                Link:"Groups",
            },
            {
                Link:"Ticketing",
            },
        ]
    },
    {
        Head: "Support",
        links:[
            {
              Link: "Contact Us",
            },
            {
              Link: "Online Chat",
            },
            {
              Link: "Whatsapp",
            },
            {
              Link: "Telegram",
            },
          ]
    },
    
] 


